<po-page-list #poPageListComponent
  p-title="Romaneio Cliente - Lista"
  [p-breadcrumb]="breadcrumb"
  [p-filter]="filterSettings"
>
  <div class="po-row">
    <po-button class="po-md-3" p-kind="secondary" p-label="Novo Romaneio" (p-click)="openModalNovoRomaneio()" > </po-button>
  </div>

  <po-table class="po-sm-12 po-md-12 po-lg-12"
    [p-height]="600"
    [p-hide-select-all]="true"
    [p-striped]="true"
    [p-columns]="tabelaPrincipalColunas"
    [p-items]="tabelaPrincipalItens"
    [p-actions]="tabelaPrincipalAction"
    p-hide-columns-manager="true"
    p-spacing="small"
    [p-filter-type]="poSearchFilterMode"
    p-hide-table-search="false"
  ></po-table>

</po-page-list>

<po-modal #advancedFilterModal p-title="Filtros" [p-primary-action]="advancedFilterPrimaryAction">
  <form #f="ngForm">
    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_DE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_DE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data de:">
    </po-datepicker>

    <po-datepicker
      class="po-md-6"
      name="DZ00DATA_ATE"
      [(ngModel)]="tabelaPrincipalFiltro.dados.DZ00DATA_ATE"
      p-format="dd/mm/yyyy"
      [p-iso-format]="formatExtended"
      p-label="Data até:">
    </po-datepicker>

    <po-input
      class="po-md-6"
      name="CZ00COD"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00COD"
      p-label="Código Romaneio"
      [p-maxlength]="6"
    ></po-input>

    <po-select
      class="po-md-6"
      name="CZ00STATUS"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00STATUS"
      p-label="Status"
      [p-options]="varStatus"
    ></po-select>

    <po-input
      class="po-md-6"
      name="CZ00CLIENT"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00CLIENT"
      p-label="Cliente"
      [p-maxlength]="6"
    ></po-input>

    <po-input
      class="po-md-6"
      name="CZ00PROCES"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CZ00PROCES"
      p-label="Processo"
    ></po-input>

    <po-input
      class="po-md-6"
      name="CEE7PEDIDO"
      [(ngModel)]="tabelaPrincipalFiltro.dados.CEE7PEDIDO"
      p-label="P.O. Number"
    ></po-input>
  </form>
</po-modal>

<po-modal #criarRomaneioModal p-title="Novo Romaneio Cliente" [p-primary-action]="criarRomaneioAction">

  <form #f="ngForm">

    <po-input
      class="po-md-4"
      name="CC5PEDEXP"
      [(ngModel)]="filtroPedidoCliente.CC5PEDEXP"
      p-label="Ordem PO"
      (p-change)="getClientePedido()"
    ></po-input>

    <po-input
      class="po-md-4"
      name="CC5PEDMI"
      [(ngModel)]="filtroPedidoCliente.CC5PEDMI"
      p-label="Pedido MI"
      (p-change)="getClientePedido()"
    ></po-input>

    <po-input
      class="po-md-4"
      name="CC5NUM"
      [(ngModel)]="filtroPedidoCliente.CC5NUM"
      p-label="Número Pedido"
      (p-change)="getClientePedido()"
    ></po-input>

    <po-lookup
      class="po-md-12"
      name="codigoCliente"
      [(ngModel)]="novoCadastroRomaneio.CZ00CLIENT"
      p-field-label="CA1NREDUZ"
      p-field-value="CA1COD"
      p-label="Cliente"
      [p-columns]="columnsClienteFilters"
      [p-field-format]="fieldFormaterClienteFilters"
      [p-filter-service]="clienteLookupService"
      [p-advanced-filters]="advancedClienteFilters"
      [p-literals]="{ modalTitle: 'Cliente' }"
      (p-selected)="clienteSelecionado($event)"
    ></po-lookup>
  </form>

</po-modal>

<po-modal #editarDadosEtapaModal p-title="Editar Dados Romaneio" [p-primary-action]="salvarDadosRomaneio">
  <form #f="ngForm">
    <po-divider class="po-md-12" p-label="1ª Etapa"></po-divider>
    <po-lookup class="po-md-6"
      name="CZ00CAMICP"
      p-label="Truck Company / Transportadora"
      [(ngModel)]="alteraRomaneio.CZ00CAMICP"
      p-field-label="CA4NOME"
      p-field-value="CA4COD"
      [p-columns]="columnsTransportadoraFilters"
      [p-field-format]="fieldFormaterTransportadoraFilters"
      [p-filter-service]="transportadoraService"
      [p-advanced-filters]="advancedTransportadoraFilters"
      [p-literals]="{ modalTitle: 'Transportadora' }">
    </po-lookup>
    <po-input class="po-md-6"
      name="CZ00PROCES"
      p-label="Process / Processo"
      [(ngModel)]="alteraRomaneio.CZ00PROCES">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00NCERT"
      p-label="Nº Certificado"
      [(ngModel)]="alteraRomaneio.CZ00NCERT">
    </po-input>
    <po-divider class="po-md-12" p-label="2ª Etapa"></po-divider>
    <po-lookup class="po-md-6"
      name="CZ00PLACA"
      p-label="Truck Plate / Placa Veículo"
      [(ngModel)]="alteraRomaneio.CZ00PLACA"
      p-field-value="CDA3PLACA"
      p-field-label="CDA3DESC"
      [p-columns]="veiculoColumnsFilters"
      [p-field-format]="veiculoFieldFormaterFilters"
      [p-filter-service]="veiculoLookupService"
      [p-advanced-filters]="veiculoAdvancedFilters"
      [p-literals]="{ modalTitle: 'Veículo' }"
      [p-required]="true"
      [p-disabled]="bloqueiaPlaca">
    </po-lookup>
    <po-input class="po-md-6"
      name="CZ00COTNER"
      p-label="Container / Container"
      [(ngModel)]="alteraRomaneio.CZ00COTNER">
    </po-input>
    <po-number class="po-md-6"
      name="NZ00TARA"
      p-label="Tare / Tara"
      [(ngModel)]="alteraRomaneio.NZ00TARA">
    </po-number>
    <po-input class="po-md-6"
      name="CZ00SELOD"
      p-label="Definitive Seal / Lacre Definitivo"
      [(ngModel)]="alteraRomaneio.CZ00SELOD">
    </po-input>
    <po-input class="po-md-6"
      name="CZ00SELOP"
      p-label="Provisional Seal / Lacre Provisório"
      [(ngModel)]="alteraRomaneio.CZ00SELOP">
    </po-input>
    <po-datepicker class="po-md-3"
      name="DZ00DTACAR"
      p-label="Data de Carregamento"
      [(ngModel)]="alteraRomaneio.DZ00DTACAR">
    </po-datepicker>
    <po-input class="po-md-3"
      name="CZ00HRACAR"
      p-label="Hora do Carregamento"
      [(ngModel)]="alteraRomaneio.CZ00HRACAR"
      p-mask="99:99:99">
    </po-input>
    <po-divider class="po-md-12" p-label="Outros dados"></po-divider>
    <po-number class="po-md-6"
      name="NZ00PESLIM"
      p-label="Limit Weight / Peso Limite"
      [(ngModel)]="alteraRomaneio.NZ00PESLIM">
    </po-number>
    <po-input class="po-md-6"
      name="CZ00FRETCP"
      p-label="Shipping Company"
      [(ngModel)]="alteraRomaneio.CZ00FRETCP">
    </po-input>
  </form>
</po-modal>

<po-modal #modalInfCertificado p-title="Informações do Certificado" p-size="md" p-hide-close="true">
  <div class="po-md-6">
    <po-table class="po-md-12"
      [p-height]="217"
      p-container="shadow"
      [p-columns]="tabelaUrColumns"
      [p-items]="tabelaUrItens"
      (p-selected)="URSelecionada($event)"
      (p-unselected)="URSelecionada($event)"
      p-spacing="small"
      [p-striped]="true"
      [p-selectable]="true"
      [p-single-select]="true"
      [p-hide-select-all]="true"
      [p-hide-table-search]="true"
      [p-hide-columns-manager]="true">
    </po-table>
  </div>
  <form #formInfCertificado="ngForm">
    <div class="po-md-6">
      <po-select class="po-md-6"
        name="tratamento"
        p-label="Tratamento"
        [p-options]="optionsTratamento"
        [(ngModel)]="dadosInfCertificado.CZEXTKD"
        [p-required]="true">
      </po-select>
      <po-select class="po-md-6"
        name="assinatura"
        p-label="Técnico/Assinatura"
        [p-options]="optionsTecnico"
        [(ngModel)]="dadosInfCertificado.CZEXTEC"
        [p-required]="true">
      </po-select>
      <po-textarea class="po-md-12"
        name="informacaolote"
        p-label="Informações Lote"
        [(ngModel)]="dadosInfCertificado.CZEXINF"
        p-rows="5">
      </po-textarea>
    </div>
  </form>
  <po-modal-footer>
    <po-button p-label="Voltar"       p-danger="true"     (p-click)="closeModalInfCertificado()"></po-button>
    <po-button p-label="Gravar"       p-kind="primary"    (p-click)="gravarModalInfCertificado()" [p-disabled]="formInfCertificado.invalid"></po-button>
    <po-button p-label="Certificados" p-kind="secondary"  (p-click)="certificadosModalInfCertificado()" [p-disabled]="dadosInfCertificado.NQTDZ02UR === 0"></po-button>
  </po-modal-footer>
</po-modal>
